import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedRelative, FormattedTime } from 'react-intl';
import { Link } from 'react-router-dom';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import { commentOnThisPage } from './styles';
import { configs } from '../../configs';
import { getTokenRacerId } from '../../utils/isLoggedIn';
import { IndividualResultsStreams } from '../../data/IndividualResultsStreams';
import { nobleParams } from '../../shared/util';
import { postResultComment } from '../../data/EventResultsStreams';
import { profileUserImageUrl } from '../../utils/profileImageUrl';

export class CommentOnThisPageComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  static defaultProps = {
    commentsData: { Result: { comments: [] } },
  };

  state = {
    value: '',
    inProgress: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const curNobleParams = nobleParams(this.props);
    const nextNobleParams = nobleParams(nextProps);
    if (!_.isEqual(curNobleParams, nextNobleParams)) {
      IndividualResultsStreams.pullLikesComments(nextNobleParams);
    }
  }

  /**
   * For posting a comment
   * @return {{racerId, eventId, eventCourseId, resultEntryId}}
   */
  apiParams = () => {
    const {
      modal: {
        props: {
          result: {
            racerId,
            eventId,
            eventCourseId,
            entryId,
          } = {}
        } = {}
      } = {}
    } = this.props;
    return {racerId, eventId, eventCourseId, resultEntryId: entryId};
  };

  comment() {
    const params = this.apiParams();
    const {value, inProgress} = this.state;
    if (!value.trim() || inProgress) return;
    this.setState({
      inProgress: true
    }, async () => {
      const commentStream = await postResultComment({...params, body: value});
      commentStream.subscribe(this.onCommentDone);
    });
  }

  onCommentDone = (res) => {
    this.setState({
      inProgress: false
    });
    if (res.Success) {
      this.setState({
        value: ''
      });
      IndividualResultsStreams.pullLikesComments(nobleParams(this.props));
    }
  };


  onKeyPress = (event) => {
    if( event.key === 'Enter' ){
      this.props.modal.props.isLoggedIn ? this.comment() : this.props.modal.handleTouchTap();
    }
  };

  render() {
    const {
      commentsData,
      t
    } = this.props;

    // Wait for comments to load
    if(commentsData.isLoading) {
      return (<div>{t('Loading comments...')}</div>)
    }

    const { Result: { comments } } = commentsData;
    const { value } = this.state;
    const loggedInId = getTokenRacerId();
    const profPicUrl = loggedInId ? profileUserImageUrl(loggedInId, 't', true) : `${configs.cdnUrl}/images/default-athlete-gray.jpg`;

    return (
      <div style={{width:'100%'}}>
        <div>
          <Comments comments={comments} t={t} />
        </div>
        <div style={commentOnThisPage.content}>
          <img src={profPicUrl} style={commentOnThisPage.logo}/>
            {/* <TextField
              multiLine={true}
              id='result-comment'
              rows={1}
              style={commentOnThisPage.textField}
              value={value}
              underlineFocusStyle={commentOnThisPage.underline}
              underlineShow={true}
              placeholder={t('Add a comment...')}
              onChange={(event, value) => this.setState({value})}
              onKeyDown={this.onKeyPress}
              disabled={!loggedInId}
            /> */}
        </div>
      </div>
    )
  }
}

const Comments = ({comments, t}) => {
  const commentString = comments.length === 1 ? t('Comment') : t('Comments');
  return (
    <div>
      <p id='comments-number' style={commentOnThisPage.commentsStyle.p}>
        {comments.length} {commentString}
      </p>
      <div style={commentOnThisPage.commentsStyle.wrap}>
        {(comments || []).map((comment, i) => <Comment key={'c_'+i} comment={comment} />)}
      </div>
    </div>
  );
};

const Comment = ({comment}) => {

  const inputDate = new Date(comment.Date);
  const todaysDate = new Date();
  const url = `${configs.bragiUrl}/athletes/${comment.CommenterRacerId}`;
  const img = comment.LogoUrls.HasImage ? comment.LogoUrls.Small : `${configs.cdnUrl}/images/default-athlete-blue.jpg`;
  const { commentStyle } = commentOnThisPage;
  return (
    <div style={commentStyle.singleComment}>
      <Link style={commentStyle.link} to={url}>
        <img style={commentStyle.image} src={img} />
      </Link>
      <div style={commentStyle.body}>
        <div style={commentStyle.mainStyle}>
          <span style={commentStyle.name}>
            <Link style={commentStyle.link}  to={url}>
              {comment.CommenterFName}{' '}{comment.CommenterLName}
            </Link>
          </span>
          <span style={{ paddingRight: 10}}>
            { //check if inputDate is today
              inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0) ?
                <FormattedRelative value={comment.Date} />
              :
                <span>
                  <FormattedDate
                    value={new Date(comment.Date)}
                    formatMatcher='best fit'
                    month='short'
                    day='numeric'
                  />
                  { ',  ' }
                  <FormattedTime
                    value={new Date(comment.Date)}
                  />
              </span>
            }
          </span>
        </div>
        <div style={commentStyle.comment} id='comment-this-page'>
          {comment.Body}
        </div>
      </div>
    </div>
  );
};

export const CommentOnThisPage = withTranslation()(connectStream({
  commentsData: IndividualResultsStreams.getLikesCommentsStream,
})(CommentOnThisPageComponent));



/** WEBPACK FOOTER **
 ** ./components/control/CommentOnThisPage.js
 **/